import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { capturePageview } from "@/lib/posthog";

/**
 * Sole source of PostHog `$pageview` events.
 *
 * PostHog automatic pageview capture is disabled in `posthog.init`, and
 * `PageView` is never mirrored from the Meta hub into PostHog, so exactly one
 * `$pageview` fires per SPA navigation. The existing MetaPixelRouteTracker runs
 * independently and is untouched.
 */
export default function PostHogRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    capturePageview(location.pathname);
  }, [location.pathname, location.search]);

  return null;
}
